import type { ColumnElementProps } from './Column.type';
import { getColumnAttributes } from './utils';

// Used by Orchid
export function ColumnElement(props: ColumnElementProps) {
  const { children } = props;

  return <div {...getColumnAttributes(props)}>{children}</div>;
}
